import { AppNotificationSeverity } from '@src/components/GlobalToasts/AppInboxToast/types';
import { logger } from '@talos/kyoko';
import type { AppNotification } from './AppNotificationsMonitorContainer';

export function appNotificationSeverityToToastVariant(severity: AppNotification['Severity']): AppNotificationSeverity {
  if (!AppNotificationSeverity[severity]) {
    logger.warn(`Unknown notification severity: ${severity}.  Defaulting to Low`);
    return 'Low';
  }
  return severity;
}
